import LoadingSpinner from '#atoms/LoadingSpinner';
import { InfoSection } from '#pages/DashboardChartForm/components/InfoSection';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { Suspense, useState } from 'react';
import { ExerciseRecord } from './ExerciseRecord';
import { HealthRecord } from './HealthRecord';
import { Rating } from './Rating';
import { Tab } from './components/Tab';

export const DashboardChartPage = () => {
  const tabList = ['운동 기록', '건강 기록', '평가'];

  const [selectedTab, setSelectedTab] = useState<string>(tabList[0]);

  return (
    <>
      <PrevHeaderBarWithTitleTemplate title="운동차트" defaultBackground>
        <div className="h-217">
          <Suspense fallback={<LoadingSpinner />}>
            <InfoSection />
          </Suspense>
        </div>
        <Tab
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabList={['운동 기록', '건강 기록', '평가']}
        />
        <div className="h-24 w-full"></div>
        {selectedTab === '운동 기록' && <ExerciseRecord />}
        {selectedTab === '건강 기록' && <HealthRecord />}
        {selectedTab === '평가' && <Rating />}
      </PrevHeaderBarWithTitleTemplate>
    </>
  );
};
